module.exports = __webpack_public_path__ + "img/9.5f77d201.jpeg";